import { connect } from "react-redux";
import AddJobForm from "./add-job-form";

import {
	onTitleChanged,
	onDateChanged,
	onTypeChanged,
	onCustomerIdChanged,
	onSiteIdChanged,
	onStaffIdChanged,
	onNotesChanged,
	onFileChanged,
	onSave,
	onClose,
} from "../../actions";
import { onUploadReset } from "features/forms/actions";

const mapStateToProps = ({ customers, jobs, sites, staff }) => ({
	job: jobs.currentJob,
	customerList: customers.pagination?.results,
	siteList: sites.pagination?.results,
	staffList: staff.pagination?.results,
	isAddModalShowing: jobs.isAddModalShowing,
	isEditModalShowing: jobs.isEditModalShowing,
});

const mapDispatchToProps = {
	onTitleChanged,
	onDateChanged,
	onTypeChanged,
	onCustomerIdChanged,
	onSiteIdChanged,
	onStaffIdChanged,
	onNotesChanged,
	onFileChanged,
	onSave,
	onClose,
	onUploadReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddJobForm);
